import { PartyAgreements } from "./Agreements.ts";
import type { Party } from "./CaseModel.ts";

export type AgreementType = "none" | keyof Omit<PartyAgreements, "partyId">;

const helperWillNotCompileInCaseNewAgreementIsAdded: {
  [type in AgreementType]: void;
} = {
  afterTheEventInsurance: undefined,
  barristerCfa: undefined,
  lawFirmCfa: undefined,
  none: undefined,
  thirdPartyFunding: undefined,
};

export function allAgreementTypes(): AgreementType[] {
  return Object.keys(
    helperWillNotCompileInCaseNewAgreementIsAdded
  ) as AgreementType[];
}

export function isAgreementType(type: string): type is AgreementType {
  return Object.keys(helperWillNotCompileInCaseNewAgreementIsAdded).includes(
    type
  );
}

/**
 * The agreement types a case list shows for a case: those active for at least
 * one client party. Agreements of other parties, and inactive ones, don't count.
 */
export function getActiveClientAgreementTypes(
  parties: Pick<Party, "id" | "client">[],
  agreements: PartyAgreements[]
): string[] {
  const clientIds = new Set(
    parties.filter(({ client }) => client).map(({ id }) => id)
  );
  const types = new Set<string>();
  for (const a of agreements) {
    if (!clientIds.has(a.partyId)) continue;
    if (a.lawFirmCfa?.active) types.add("lawFirmCfa");
    if (a.barristerCfa?.active) types.add("barristerCfa");
    if (a.thirdPartyFunding?.active) types.add("thirdPartyFunding");
    if (a.afterTheEventInsurance?.active) types.add("afterTheEventInsurance");
  }
  return [...types];
}
